import { render, staticRenderFns } from "./Vagas_Encaminhadas.vue?vue&type=template&id=a0246b20"
import script from "./Vagas_Encaminhadas.vue?vue&type=script&lang=js"
export * from "./Vagas_Encaminhadas.vue?vue&type=script&lang=js"
import style0 from "./Vagas_Encaminhadas.vue?vue&type=style&index=0&id=a0246b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports